// Voorleesknop op het bord: de schakelaar per gezinslid (readAloudApp.nl.ts).
export const appReadAloudEn = {
    setting: 'Read-aloud button on the board',
    settingHint: 'A large button reads tasks, appointments and messages aloud. Helpful for those who cannot read yet.',
    language: 'Language for reading aloud and calls',
    languageHint: 'The board reads tasks, appointments and calls aloud in this language. Titles are read exactly as you type them.',
    languageBoard: 'Board language ({language})',
    languageMember: 'Reading-aloud language',
    languageMemberHint: 'Titles are read exactly as you type them.',
    languageFamily: 'Same as the family ({language})',
    saved: 'Saved',
};
//# sourceMappingURL=readAloudApp.en.js.map